module.exports = __webpack_public_path__ + "img/home-odd-jobs-bg.8bb1a3fb.jpg";